/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CountryDto } from '../../models/country-dto';

export interface GetAll6$Params {
}

export function getAll6(http: HttpClient, rootUrl: string, params?: GetAll6$Params, context?: HttpContext): Observable<StrictHttpResponse<CountryDto>> {
  const rb = new RequestBuilder(rootUrl, getAll6.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CountryDto>;
    })
  );
}

getAll6.PATH = '/countries';
